var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1668 38.5V34.8333C31.1668 32.8884 30.3942 31.0232 29.0189 29.6479C27.6437 28.2726 25.7784 27.5 23.8335 27.5H9.16683C7.22191 27.5 5.35665 28.2726 3.98138 29.6479C2.60611 31.0232 1.8335 32.8884 1.8335 34.8333V38.5",
    stroke: "#3d3d5c",
    strokeWidth: 3.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4998 20.1667C20.5499 20.1667 23.8332 16.8834 23.8332 12.8333C23.8332 8.78324 20.5499 5.5 16.4998 5.5C12.4497 5.5 9.1665 8.78324 9.1665 12.8333C9.1665 16.8834 12.4497 20.1667 16.4998 20.1667Z",
    stroke: "#3d3d5c",
    strokeWidth: 3.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1665 38.4999V34.8333C42.1653 33.2084 41.6245 31.63 40.629 30.3459C39.6335 29.0617 38.2397 28.1445 36.6665 27.7383",
    stroke: "#3d3d5c",
    strokeWidth: 3.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3335 5.73828C30.9109 6.14217 32.3091 7.05957 33.3075 8.34585C34.3059 9.63213 34.8479 11.2141 34.8479 12.8424C34.8479 14.4708 34.3059 16.0528 33.3075 17.339C32.3091 18.6253 30.9109 19.5427 29.3335 19.9466",
    stroke: "#3d3d5c",
    strokeWidth: 3.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.dfd87b60905dd5d4afdbd3884c53b19b.svg";
export { ForwardRef as ReactComponent };